import React, { useState } from 'react';
import { useAppContext } from '../../hooks/useAppContext';
import EmptyState from '../common/EmptyState';
import JobItem from './JobItem';

const JobList = () => {
  const { jobs, isLoadingJobs, loadJobs } = useAppContext();
  const [statusFilter, setStatusFilter] = useState('All');
  const [isFiltering, setIsFiltering] = useState(false);

  const handleFilterChange = async (e) => {
    const newFilter = e.target.value;
    setStatusFilter(newFilter);
    setIsFiltering(true);
    await loadJobs(newFilter === 'All' ? null : newFilter);
    setIsFiltering(false);
  };

  if (isLoadingJobs) {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <div style={{ fontSize: '2rem', marginBottom: '10px' }}>⏳</div>
        <p style={{ color: '#718096' }}>Loading jobs...</p>
      </div>
    );
  }

  return (
    <div>
      {/* Filter Dropdown */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
        <label style={{ color: '#4a5568', fontWeight: 600, fontSize: '0.9rem' }}>
          Filter by Status:
        </label>
        <select
          value={statusFilter}
          onChange={handleFilterChange}
          disabled={isFiltering}
          style={{
            padding: '8px 16px',
            borderRadius: '8px',
            border: '2px solid #e2e8f0',
            background: 'white',
            color: '#4a5568',
            fontWeight: 500,
            fontSize: '0.9rem',
            cursor: isFiltering ? 'not-allowed' : 'pointer',
            outline: 'none',
            minWidth: '160px'
          }}
        >
          <option value="All">📋 All</option>
          <option value="Open">✅ Open</option>
          <option value="On Hold">⏸️ On Hold</option>
          <option value="Closed">🔒 Closed</option>
        </select>
        {isFiltering && (
          <span style={{ color: '#667eea', fontSize: '0.9rem', fontWeight: 500 }}>
            Filtering...
          </span>
        )}
      </div>

      {/* Jobs Count */}
      {jobs.length > 0 && (
        <div style={{ marginBottom: '15px', color: '#718096', fontSize: '0.9rem', fontWeight: 500 }}>
          Showing {jobs.length} job{jobs.length !== 1 ? 's' : ''}
          {statusFilter !== 'All' && ` (${statusFilter})`}
        </div>
      )}

      {/* Jobs List */}
      {jobs.length === 0 ? (
        <EmptyState
          message={
            statusFilter === 'All'
              ? "No jobs created yet. Create your first job above."
              : `No ${statusFilter.toLowerCase()} jobs found. Try a different filter.`
          }
          icon="📋"
        />
      ) : (
        <div className="job-list">
          {jobs.map(job => (
            <JobItem key={job.id} job={job} />
          ))}
        </div>
      )}
    </div>
  );
};

export default JobList;